$( document ).ready(function() {
	$('.menu').click(function() {
		$('.overlay').removeClass( "slideOutRight hide" );
		$('.overlay').addClass( "animated slideInRight show" );
		
		$('#close').click(function() {
			$('.overlay').removeClass( "slideInRight hide" );
			$('.overlay').addClass( "animated slideOutRight" );
		});
		
	});

	$('.overlay ul li a').click(function() {		
		$('.overlay').removeClass( "slideInRight hide" );
		$('.overlay').addClass( "animated slideOutRight" );	
			
	}); 	
});